import React from "react";
import AnimatedSection from "./AnimatedSection";
import img1 from "../assets/Start Your Live Party.png";
import img2 from "../assets/Rooms.png";
import img3 from "../assets/Send Gifts.png";
import img4 from "../assets/Room Levels.png";
import img5 from "../assets/Family Space.png";
import img6 from "../assets/Messages.png";
import img7 from "../assets/Explore.png";
import img8 from "../assets/Profile.png";
import img9 from "../assets/Payment Methods.png";
import img10 from "../assets/Withdraw.png";

export default function Allservices() {
  const services = [
    {
      title: "Start Your Live Party",
      description:
        "Create your own live room and connect with people in real time. Enjoy live calls, interactive group chat rooms, and smooth live communication. Meet new people, share moments, and build meaningful connections in a fun and easy way—all from one powerful platform.",
      image: img1,
    },
     {
      title: "Rooms",
      description:
        "Explore live rooms hosted by broadcasters from around the world. Join public rooms, watch live sessions, interact with hosts, and connect with other users in real time. Discover trending rooms and enjoy nonstop live entertainment.",
      image: img2,
    },
    {
      title: "Send Gifts",
      description:
        "Send virtual gifts to your favorite hosts and friends during live sessions. Choose from different gift categories, express your feelings, and support broadcasters in real time. Gifting helps you stand out, build connections, and increase engagement inside the live room.",
      image: img3,
    },
    {
      title: "Room Levels",
      description:
        "Increase your room level by completing tasks and staying active in live chat rooms. As your room level upgrades, unlock exclusive rewards, special features, and higher status. Higher room levels help you attract more users and create a premium live experience.",
      image: img4,
    },
    {
      title: "Family Space",
      description:
        "Create private or public family channels where members can stream, share, and enjoy content together in one secure space. Perfect for friends, teams, or communities, these channels keep everyone connected no matter where they are. Host group events, watch parties, or collaborative streams, and share your favorite moments instantly. Whether it’s celebrating milestones, collaborating on projects, or simply hanging out virtually, family channels make it easy to stay close and create lasting memories with the people who matter most.Bring your family together in one dedicated space. Share posts, interact with members, manage family activities, and keep all conversations organized. A perfect place for teamwork, bonding, and daily interactions.",
      image: img5,
    },
     {
      title: "Messages",
      description:
        "View all your messages, chat requests, and important notifications in one place. See who visited your profile, manage family invitations, check recharge updates, and stay informed with official announcements. Easily continue your private chats and family channel conversations without missing anything.",
      image: img6,
    },
    {
      title: "Explore",
      description:
        "Discover live broadcasters from around the world in one place. Explore new profiles, follow your favorite hosts, and stay updated with their live sessions. Find trending creators, connect instantly, and enjoy nonstop live entertainment.",
      image: img7,
    },
    {
      title: "Profile",
      description:
        "View complete user information including profile details, level, contribution, followers, and achievements. Explore family status, VIP level, charisma score, gift wall, and earned medals. A complete profile overview designed to showcase user identity and activity.",
      image: img8,
    },
     {
      title: "Payment Methods",
      description:
        "Choose and add your preferred local payment methods for fast and secure withdrawals. Easily manage multiple payment options, check service fees, and withdraw your earnings with confidence. Designed to support popular local wallets and banks for your convenience.",
      image: img9,
    },
     {
      title: "Withdraw",
      description:
        "Withdraw your earned balance or exchange beans easily and securely. Choose your preferred payment method, enter the withdrawal or exchange amount, and complete your transaction with confidence. Transparent limits and clear instructions ensure a smooth and reliable payout experience.",
      image: img10,
    },
  ];

  return (
    <div className="bg-gradient-to-b from-[#0a0a0f] to-[#111] py-20">
      <div className="max-w-6xl mx-auto px-4 space-y-24">
        {services.map((service, index) => (
          <AnimatedSection
            key={index}
            className={`flex flex-col md:flex-row items-center gap-12 ${
              index % 2 !== 0 ? "md:flex-row-reverse" : ""
            }`}
            delay={0.05 * index}
          >
            {/* Image Section with Tilt */}
            <div className="md:w-2/5 relative group perspective">
              <div className="relative transform transition-transform duration-500 group-hover:rotate-2 group-hover:scale-105 rounded-2xl overflow-hidden shadow-lg shadow-[#FF512F]/40">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-[350px] object-contain bg-black p-2"
                />
                <div className="absolute inset-0 bg-[#FF512F]/30 opacity-0 group-hover:opacity-100 transition duration-700 ease-out"></div>
              </div>
            </div>

            {/* Text Section */}
            <div className="md:w-3/5 space-y-6 text-center md:text-left">
              <h2 className="text-3xl md:text-4xl font-bold leading-tight text-[#FF512F]">
                {service.title}
              </h2>
              <hr />
              <p className="text-gray-300 leading-relaxed">
                {service.description}
              </p>
            </div>
          </AnimatedSection>
        ))}
      </div>
    </div>
  );
}
